import Entity from './entity'

export default class Payment extends Entity<string>{
    isPaySuccess: boolean;
    creatorUserName: string;
    rechargeType: number;
    payoff: number;
    creationTime: string;
}